import { render, staticRenderFns } from "./EditTaxi.component.vue?vue&type=template&id=1c482d82&scoped=true"
import script from "./EditTaxi.component.vue?vue&type=script&lang=ts"
export * from "./EditTaxi.component.vue?vue&type=script&lang=ts"
import style0 from "./EditTaxi.component.vue?vue&type=style&index=0&id=1c482d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c482d82",
  null
  
)

export default component.exports